/* CUSTOM: Versandbalken im Warenkorb-Drawer (komplett custom, Okt. 2026).
   Ist Gratis-Versand erreicht, blendet assets/cart-compact.css den Balken aus, es steht nur noch der
   Glueckwunsch da. Wird die Schwelle im Drawer erreicht (Menge erhoeht oder Produkt hinzugefuegt),
   fliegt vorher einmal Super Jay (Papriko-Figur) ueber den Balken: Er landet an der alten Spitze, zieht
   die gruene Fuellung bis ans Ende, schiesst rechts hinaus, es funkelt kurz, dann klappt der Balken zu.
   Beim ersten Produkt im leeren Warenkorb (Gratis-Versand noch nicht erreicht) gibt es einen kleineren
   Auftritt: Super Jay schiebt die Fuellung vom Anfang zur neuen Spitze, es funkelt dort, dann dreht er nach
   oben ab. Weitere Produkte darunter bewusst ohne Animation (Lisa: "nicht bei jedem einzelnen Produkt").
   Adventskalender-Special: Jedes Mal, wenn ein Adventskalender dazukommt (Zeilen mit data-jh-advent in
   snippets/cart-drawer.liquid), fliegt der Weihnachts-Super-Jay - beim Erreichen von Gratis-Versand ueber
   den Balken (statt des normalen Super Jay, mit Schneeflocken), sonst einmal quer durch den Kopf.
   Nur Transform-/Clip-Animationen (Web Animations API), damit es auch auf dem Handy fluessig laeuft.
   Dawn ersetzt den Drawer-Inhalt dabei komplett (Section Rendering), deshalb merkt sich dieses Script
   den letzten Stand selbst und beobachtet den Drawer per MutationObserver.
   Bilder (freigestellt, durchsichtiger Hintergrund, Figur voll deckend): assets/super-jay-fliegt.webp
   (222 x 90 px, aus "super_jay_fuehrt_deine_bestellung_aus.jpg") und assets/super-jay-weihnacht.webp
   (224 x 90 px, aus "johnnys_adventskalender_2024_super_jay.jpg"). Die Pfade kommen per data-jay-src /
   data-xmas-src vom Script-Tag in snippets/cart-drawer.liquid. */
(function () {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  const script = document.currentScript;
  const JAY_HEIGHT = 36;
  const FIGURES = {
    jay: { src: (script && script.dataset.jaySrc) || '', width: Math.round((JAY_HEIGHT * 222) / 90), nose: 0.8, sparkle: '✨' },
    xmas: { src: (script && script.dataset.xmasSrc) || '', width: Math.round((JAY_HEIGHT * 224) / 90), nose: 0.85, sparkle: '❄' },
  };
  const FLY_MS = 1600;
  const BOOST_MS = 1300;
  const XMAS_MS = 2000;
  const GLIDE = 'cubic-bezier(0.45, 0, 0.25, 1)';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  let preloaded = false;
  const preload = () => {
    if (preloaded) return;
    preloaded = true;
    const load = () => Object.values(FIGURES).forEach((f) => f.src && (new Image().src = f.src));
    if ('requestIdleCallback' in window) requestIdleCallback(load);
    else setTimeout(load, 1500);
  };

  const readState = () => {
    let advent = 0;
    drawer.querySelectorAll('[data-jh-advent] .quantity__input').forEach((input) => {
      advent += parseInt(input.value, 10) || 0;
    });
    const wrapper = drawer.querySelector('#cart-progress-wrapper');
    const bar = wrapper && wrapper.querySelector('#cart-progress-bar');
    if (!wrapper || !bar) return { wrapper: null, full: false, width: 0, advent };
    const full = wrapper.classList.contains('full');
    return { wrapper, full, width: full ? 100 : parseFloat(bar.style.width) || 0, advent };
  };

  let last = readState();
  if (!last.full) preload();
  let busyElement = null;

  const createFigure = (container, figure, left, top) => {
    const img = document.createElement('img');
    img.className = 'jh-superjay';
    img.src = figure.src;
    img.alt = '';
    img.width = figure.width;
    img.height = JAY_HEIGHT;
    img.setAttribute('aria-hidden', 'true');
    img.style.left = `${left}px`;
    img.style.top = `${top}px`;
    container.append(img);
    return img;
  };

  const sparkleAt = (container, x, y, delay, offsets, char) => {
    offsets.forEach(([dx, dy], i) => {
      const sparkle = document.createElement('span');
      sparkle.className = char === '❄' ? 'jh-sparkle jh-sparkle--snow' : 'jh-sparkle';
      sparkle.textContent = char;
      sparkle.setAttribute('aria-hidden', 'true');
      sparkle.style.left = `${x}px`;
      sparkle.style.top = `${y}px`;
      container.append(sparkle);
      sparkle.animate(
        [
          { transform: 'translate(0, 0) scale(0.2)', opacity: 0 },
          { transform: `translate(${dx}px, ${dy}px) scale(1)`, opacity: 1, offset: 0.4 },
          { transform: `translate(${dx * 2}px, ${dy * 2 - 8}px) scale(0.6)`, opacity: 0 },
        ],
        { delay: delay + i * 70, duration: 650, easing: 'ease-out', fill: 'both' }
      );
    });
  };

  const bumpMessage = (wrapper, delay) => {
    const message = wrapper && wrapper.querySelector('.goal-message');
    if (!message) return;
    message.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.06)' }, { transform: 'scale(1)' }], {
      delay,
      duration: 450,
      easing: 'ease-out',
    });
  };

  const canAnimate = (el, figure) => el && el.animate && figure.src && !reduceMotion.matches;

  // Erstes Produkt, Gratis-Versand fehlt noch: Super Jay schiebt die Fuellung zur neuen Spitze und dreht ab
  const boost = (wrapper, fromWidth, toWidth, figure) => {
    const track = wrapper.querySelector('.cart-progress-bar-container');
    const bar = wrapper.querySelector('#cart-progress-bar');
    if (!track || !bar || !canAnimate(wrapper, figure)) return;

    busyElement = wrapper;
    const jay = createFigure(wrapper, figure, track.offsetLeft, track.offsetTop + track.offsetHeight / 2 - JAY_HEIGHT / 2);
    const trackWidth = track.offsetWidth;
    const nose = figure.width * figure.nose;
    const xStart = (fromWidth / 100) * trackWidth - nose;
    const xEnd = (toWidth / 100) * trackWidth - nose;

    // Der Balken steht schon auf dem neuen Stand und wird von der alten Spitze aus aufgedeckt
    const hidden = (1 - fromWidth / toWidth) * 100;
    const grow = bar.animate(
      [{ clipPath: `inset(0 ${hidden}% 0 0 round 99px)` }, { clipPath: 'inset(0 0% 0 0 round 99px)' }],
      { delay: BOOST_MS * 0.15, duration: BOOST_MS * 0.45, easing: GLIDE, fill: 'both' }
    );

    const fly = jay.animate(
      [
        { transform: `translate(${xStart - 30}px, 8px) scale(0.4) rotate(10deg)`, opacity: 0, easing: 'ease-out' },
        { transform: `translate(${xStart}px, 0) scale(1) rotate(0deg)`, opacity: 1, offset: 0.15, easing: GLIDE },
        { transform: `translate(${xEnd}px, 0) scale(1) rotate(0deg)`, opacity: 1, offset: 0.6, easing: 'ease-out' },
        { transform: `translate(${xEnd + 30}px, -30px) scale(1.05) rotate(-22deg)`, opacity: 1, offset: 0.78, easing: 'ease-in' },
        { transform: `translate(${xEnd + 90}px, -70px) scale(0.7) rotate(-32deg)`, opacity: 0 },
      ],
      { duration: BOOST_MS, fill: 'forwards' }
    );

    const tipX = track.offsetLeft + (toWidth / 100) * trackWidth - 8;
    sparkleAt(wrapper, tipX, track.offsetTop - 6, BOOST_MS * 0.6, [[-4, -12], [8, -2]], figure.sparkle);
    bumpMessage(wrapper, BOOST_MS * 0.6);

    fly.finished
      .catch(() => {})
      .then(() => {
        if (!wrapper.isConnected) return;
        wrapper.querySelectorAll('.jh-superjay, .jh-sparkle').forEach((el) => el.remove());
        grow.cancel();
        if (busyElement === wrapper) busyElement = null;
      });
  };

  const celebrate = (wrapper, fromWidth, figure) => {
    const track = wrapper.querySelector('.cart-progress-bar-container');
    const bar = wrapper.querySelector('#cart-progress-bar');
    if (!track || !bar || !canAnimate(wrapper, figure)) return false;

    busyElement = wrapper;
    const fullColor = getComputedStyle(bar).backgroundColor;
    wrapper.classList.add('is-celebrating');

    // Echter Balken bleibt blau auf dem alten Stand, darueber waechst die gruene Fuellung
    bar.style.transition = 'none';
    bar.style.setProperty('--progress-bar-color', 'initial');
    bar.style.width = `${fromWidth}%`;

    const fill = document.createElement('span');
    fill.className = 'jh-cele-fill';
    fill.style.backgroundColor = fullColor;
    track.append(fill);

    const jay = createFigure(wrapper, figure, track.offsetLeft, track.offsetTop + track.offsetHeight / 2 - JAY_HEIGHT / 2);
    const trackWidth = track.offsetWidth;
    const nose = figure.width * figure.nose;
    const xStart = (fromWidth / 100) * trackWidth - nose;
    const xEnd = trackWidth - nose;

    jay.animate(
      [
        { transform: `translate(${xStart - 40}px, 10px) scale(0.4) rotate(10deg)`, opacity: 0, easing: 'ease-out' },
        { transform: `translate(${xStart}px, 0) scale(1) rotate(0deg)`, opacity: 1, offset: 0.15, easing: GLIDE },
        { transform: `translate(${xEnd}px, 0) scale(1) rotate(0deg)`, opacity: 1, offset: 0.65, easing: 'ease-in' },
        { transform: `translate(${xEnd + figure.width + 40}px, -26px) scale(0.9) rotate(-14deg)`, opacity: 0 },
      ],
      { duration: FLY_MS, fill: 'forwards' }
    );

    // Gruene Fuellung folgt genau Super Jays Faust (gleiche Strecke, gleiche Kurve)
    fill.animate([{ clipPath: `inset(0 ${100 - fromWidth}% 0 0)` }, { clipPath: 'inset(0 0% 0 0)' }], {
      delay: FLY_MS * 0.15,
      duration: FLY_MS * 0.5,
      easing: GLIDE,
      fill: 'both',
    });

    // Kurzes Funkeln (beim Adventskalender Schneeflocken) am Balkenende, der Glueckwunsch huepft einmal
    sparkleAt(wrapper, track.offsetLeft + trackWidth - 10, track.offsetTop - 6, FLY_MS * 0.65, [[-6, -14], [8, -4], [-2, 10]], figure.sparkle);
    bumpMessage(wrapper, FLY_MS * 0.65);

    // Balken klappt zu, danach aufraeumen (CSS blendet ihn im vollen Zustand ganz aus)
    const trackStyle = getComputedStyle(track);
    const collapse = track.animate(
      [
        { height: `${track.offsetHeight}px`, marginTop: trackStyle.marginTop, marginBottom: trackStyle.marginBottom, opacity: 1 },
        { height: '0px', marginTop: '0px', marginBottom: '0px', opacity: 0 },
      ],
      { delay: FLY_MS * 0.8, duration: 380, easing: 'ease-in-out', fill: 'forwards' }
    );

    collapse.finished
      .catch(() => {})
      .then(() => {
        if (!wrapper.isConnected) return;
        wrapper.classList.remove('is-celebrating');
        wrapper.querySelectorAll('.jh-superjay, .jh-sparkle').forEach((el) => el.remove());
        fill.remove();
        collapse.cancel();
        bar.style.transition = '';
        bar.style.removeProperty('--progress-bar-color');
        bar.style.width = '100%';
        if (busyElement === wrapper) busyElement = null;
      });
    return true;
  };

  // Adventskalender dazu, Balken schon voll: Weihnachts-Super-Jay fliegt einmal quer durch den Kopf,
  // in leichten Wellen, hinter ihm rieseln Schneeflocken
  const xmasFly = (wrapper) => {
    const header = drawer.querySelector('.drawer__header');
    const figure = FIGURES.xmas;
    if (!canAnimate(header, figure)) return;

    busyElement = header;
    const width = header.offsetWidth;
    const top = header.offsetHeight / 2 - JAY_HEIGHT / 2 - 5; // etwas hoeher, sonst verdeckt der Bereich darunter die Fuesse
    const jay = createFigure(header, figure, 0, top);
    const xFrom = -figure.width - 10;
    const xTo = width + 10;
    const xAt = (p) => xFrom + (xTo - xFrom) * p;

    const fly = jay.animate(
      [
        { transform: `translate(${xAt(0)}px, 8px) rotate(6deg)` },
        { transform: `translate(${xAt(0.25)}px, -6px) rotate(-4deg)` },
        { transform: `translate(${xAt(0.5)}px, 6px) rotate(4deg)` },
        { transform: `translate(${xAt(0.75)}px, -6px) rotate(-4deg)` },
        { transform: `translate(${xAt(1)}px, 4px) rotate(4deg)` },
      ],
      { duration: XMAS_MS, easing: 'linear', fill: 'forwards' }
    );
    jay.animate([{ opacity: 0 }, { opacity: 1, offset: 0.08 }, { opacity: 1, offset: 0.92 }, { opacity: 0 }], {
      duration: XMAS_MS,
      fill: 'forwards',
    });

    // Schneeflocken fallen dort, wo er gerade war
    [0.2, 0.35, 0.5, 0.65, 0.8].forEach((p, i) => {
      const flake = document.createElement('span');
      flake.className = 'jh-sparkle jh-sparkle--snow';
      flake.textContent = '❄';
      flake.setAttribute('aria-hidden', 'true');
      flake.style.left = `${xAt(p) + figure.width * 0.2}px`;
      flake.style.top = `${top + JAY_HEIGHT * 0.6}px`;
      header.append(flake);
      flake.animate(
        [
          { transform: 'translate(0, 0) scale(0.4) rotate(0deg)', opacity: 0 },
          { transform: 'translate(-3px, 8px) scale(1) rotate(60deg)', opacity: 0.9, offset: 0.3 },
          { transform: `translate(${i % 2 ? 4 : -6}px, 26px) scale(0.7) rotate(160deg)`, opacity: 0 },
        ],
        { delay: XMAS_MS * p, duration: 900, easing: 'ease-out', fill: 'both' }
      );
    });
    bumpMessage(wrapper, XMAS_MS * 0.5);

    fly.finished
      .catch(() => {})
      .then(() => {
        if (!header.isConnected) return;
        setTimeout(() => {
          header.querySelectorAll('.jh-superjay, .jh-sparkle').forEach((el) => el.remove());
          if (busyElement === header) busyElement = null;
        }, 900);
      });
  };

  new MutationObserver(() => {
    if (busyElement && busyElement.isConnected) return;
    busyElement = null;

    const now = readState();
    if (!now.full) preload();
    const adventAdded = now.advent > last.advent;
    const figure = adventAdded ? FIGURES.xmas : FIGURES.jay;
    let played = false;
    if (now.wrapper && now.full && !last.full) played = celebrate(now.wrapper, last.width, figure);
    else if (now.wrapper && !now.full && last.width === 0 && now.width > 0) {
      boost(now.wrapper, 0, now.width, figure);
      played = true;
    }
    if (adventAdded && !played) xmasFly(now.wrapper);
    last = now;
  }).observe(drawer, { childList: true, subtree: true });
})();
